import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-artwork-client',
  templateUrl: './artwork-client.component.html',
  styleUrls: ['./artwork-client.component.scss']
})
export class ArtworkClientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
